import { GlobalStyles } from '@mui/material'
import type { CSSProperties } from 'react'

import { ConfiguratorApp } from '@salsita-ai/platform-project-sdk/configurator'
import { createGetApplicationWrapperHandler } from '@salsita-ai/platform-project-sdk/domain'

import { useConfiguratorMinBlockSize } from './web-component-properties.js'

const embeddedConfiguratorRootStyle = {
  display: 'grid',
} satisfies CSSProperties

export default createGetApplicationWrapperHandler(config => {
  const EmbeddedConfiguratorApplication = () => {
    const configuratorMinBlockSize = useConfiguratorMinBlockSize()
    const configuratorMinBlockSizeCss = `${configuratorMinBlockSize}px`

    return (
      <div style={{ ...embeddedConfiguratorRootStyle, minBlockSize: configuratorMinBlockSizeCss }}>
        <ConfiguratorApp config={config} />
        <GlobalStyles
          styles={{
            ':host': {
              minBlockSize: configuratorMinBlockSizeCss,
            },
          }}
        />
      </div>
    )
  }

  return EmbeddedConfiguratorApplication
})
